import { useEffect, useState } from 'react';

import { useExamEvent, useNewExam } from '../../../../providers';
import { useExamPreviewForm } from '../../../../providers/exam-preview';
import { type ExamGraderResult } from '../types';
import { calculateExamGradingResults, mapExamFormInputToExamPaperItems } from '../utils';

export function useGetExamResult() {
  const [examResult, setExamResult] = useState<ExamGraderResult>();

  const { getValues } = useExamPreviewForm();
  const { examEvent } = useExamEvent();
  const { questions } = useNewExam();

  useEffect(() => {
    if (!examEvent || !questions.length) return;

    try {
      const result = calculateExamGradingResults({
        examEvent,
        examGraderResultInput: {
          examPaperItems: mapExamFormInputToExamPaperItems(getValues()),
          questions,
        },
      });
      setExamResult(result);
    } catch (error) {
      console.error('Grading error', error);
    }
  }, [getValues, examEvent, questions]);

  return examResult;
}
